<!-- 教师能力提升 -->
<template>
    <div class="power">
        <div class="top flex-align">
            <img class="powerbg" src="../assets/new/powerbg.png" alt="">
            <div class="projectList">
                <div class="projectItem" v-for="(item,index) in projectList" :key="index">
                    <div class="flex-align wes">
                        <div class="line"></div>
                        <span class="wes">{{ item }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="center flex-between">
            <div class="status">
                <div class="title flex-align ">
                    <img src="../assets/new/status.png" alt="">
                    项目动态
                    <span>更多></span>
                </div>
                <div class="item flex-align" v-for="(item,index) in statusList" :key="index">
                    <div class="line"></div>
                    <span class="wes">{{ item.name }}</span>
                    <span class="time">{{item.time}}</span>
                </div>
            </div>
            <div class="status">
                <div class="title flex-align ">
                    <img src="../assets/new/person.png" alt="">
                    成员感悟
                    <span>更多></span>
                </div>
                <div class="item flex-align" v-for="(item,index) in ganwuList" :key="index" @click="goVideo">
                    <div class="line"></div>
                    <span>{{ item.name }}</span>
                    <span class="time">{{item.time}}</span>
                </div>
            </div>
        </div>
        <div class="bottom flex-between">
            <div class="item flex-align">
                <div class="num flex-column-center">
                    40
                    <span>项目数量</span>
                </div>
            </div>
            <div class="item3 flex-align">
                <div class="num flex-column-center">
                    923
                    <span>参训学员数</span>
                </div>
            </div>
            <div class="item2 flex-align">
                <div class="num flex-column-center">
                    1832
                    <span>作业提交数</span>
                </div>
            </div>

            <div class="item4 flex-align">
                <div class="num flex-column-center">
                    85200
                    <span>课程学习分钟数</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                projectList: [
                    '“内蒙古自治区中部四盟市‘三科统编教材’教师线上线下混合式研修”项目',
                    '2023年内蒙古自治区中部片区国家统编教材教师培训',
                    '内蒙古中小学骨干教师“培训+跟岗”项目培训',
                    '东城区教育对口支援合作地区干部教师远程培训',
                    '“京蒙对口帮扶—乌兰察布市小学、初中教师培训项目”',
                    '密云职业学校库伦旗民族职业中等专业学校“云青蓝”工程',
                    // '兴安盟教研员进京培训跟岗项目',
                    // '顺义区新课标与课堂有效对接专题研修活动'
                ],
                statusList: [{
                        name: '首都师范大学举行内蒙古自治区中部片区2023年国家统编教材教师培训开班仪式',
                        time: '2023-8-23'
                    },
                    {
                        name: '“京蒙携手·教育振兴”第一届“驼铃杯”课堂教学大赛成功开幕',
                        time: '2023-7-20'
                    },
                    {
                        name: '2022年内蒙古自治区中部四盟市统编三科教材教师培训“道德与法治·思想政治”课程方案研讨会召开',
                        time: '2022-5-24'
                    },
                    {
                        name: '京蒙同心 携手共进  密云职校库伦职专举行＂云青蓝＂公开课活动',
                        time: '2023-4-10'
                    },
                    {
                        name: '兴安盟教育局启动教研员赴京跟岗研修项目',
                        time: '2023-3-22'
                    },
                    {
                        name: '加强职业教育京蒙协作，落实人才“组团式”帮扶——库伦职专赴北京密云职校学习实记',
                        time: '2023-3-10'
                    },
                ],
                ganwuList: [{
                        name: '数学教师培训研修感悟.mp4',
                        time: '2023-8-25'
                    },
                    {
                        name: '知耻后勇，砥砺前行.doc',
                        time: '2023-8-24'
                    },
                    {
                        name: '在时光中创造那个最好的自己.docx',
                        time: '2023-8-24'
                    },
                    {
                        name: '参加“驼铃杯”课堂教学大赛所思所获.ppt',
                        time: '2023-8-10'
                    },
                    {
                        name: '教以潜心，研以致远.mp4',
                        time: '2023-8-10'
                    },
                    {
                        name: '在岗实践计划.doc',
                        time: '2023-7-20'
                    },
                ]
            }
        },
        methods: {
            goVideo() {
                this.$router.push('/home/video')
            }
        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url("./less/power.less");
</style>